<template>
  <v-container id="home" fluid>
    <h3 class="display-2 text-xs-center">{{ timenow }}</h3>
    <h3 class="display-1 text-xs-center">{{ datenow }}</h3>
    <div class="mt-16">
      <v-img :src="swiftCheckIn" contain/>
    </div>
    <div class="button-holder">
      <v-card class="rounded-t-xl" light>
        <v-card-text>
          <v-row>
            <v-col
            cols="6"
            >
            <a @click="checkInClicked()">
              <v-img :src="checkInIcon" height="100%" width="100%"></v-img>
            </a>
            </v-col>
            <v-col
            cols="6"
            >
            <a @click="checkOutClicked()"
            >
              <v-img :src="checkOutIcon" height="100%" width="100%"></v-img>
            </a>
            </v-col>
          </v-row>
          <v-row>
            <v-col
            cols="12"
            >
            <v-btn x-large block @click="registerClicked()"
              class="rounded-xl"
              dark
            >
              <v-icon class="mr-3">
                mdi-account-circle
              </v-icon>
              Register
            </v-btn>
            </v-col>
          </v-row>
          <v-row></v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    timenow: moment().format('h:mm A'),
    datenow: '',
    checkInIcon: require('@/assets/img/Check-in-icon.svg'),
    checkOutIcon: require('@/assets/img/Check-out-icon.svg'),
    swiftCheckIn: require('@/assets/img/swift-check-in-logo.svg')
  }),
  methods: {
    time () {
      this.timenow = moment().format('h:mm A')
    },
    checkInClicked () {
      this.$router.push({ name: 'Checkin' })
    },
    checkOutClicked () {
      this.$router.push({ name: 'Checkout' })
    },
    registerClicked () {
      this.$router.push({ name: 'Register' })
    }
  },
  mounted () {
    this.interval = setInterval(this.time, 1000)
    this.datenow = moment().format('ddd, D MMMM')
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>

<style lang="css" scoped>
.button-holder {
  bottom: 0;
  position: absolute;
  margin-bottom: 0px;
  margin-left: -12px;
  width: 100%;
};
</style>
